import styled, { css } from 'styled-components/macro'
import IconDown from '../../../assets/img/icon_angle_blue_down.png'

export const DescComponent = styled.table`
  //box-shadow: 0 0.15rem 0.3rem #ccc;
  border-collapse: collapse;
  font-size: 0.7rem;
  background-color: #fff;
  width: 99.7%;
`

export const StyledTr = styled.tr`
  &:hover {
    background-color: #f2f2f2;
  }
`

export const SuffixThemeCss = (tdTheme: 'downIcon' | undefined) => {
  if (tdTheme === 'downIcon') {
    return css`
      text-align: right;
      &:after {
        content: url(${IconDown});
        padding: 0 12px;
      }
    `
  }
  return css``
}

export const StyledTd = styled.td<{ tdTheme?: 'downIcon' }>`
  padding: 0.5rem 0 0.5rem 1rem;
  border-bottom: 1px solid #d7d7d8;
  font-family: roboto;
  height: 2.4rem;

  ${(props) => SuffixThemeCss(props.tdTheme)};
  &:first-child {
    font-weight: 600;
    color: #003893;
    font-size: 14px;
    font-family: 'Montserrat';
    width: 180px;
  }
`

export const StyledTitleTd = styled(StyledTd)`
  white-space: nowrap;
`
